/**
 * CP어드민 권한정보
 */
export enum Grade {
  /** 마스터 관리자(패뷰 관리자) */
  MASTER = "MASTER",
  /** 사용자(회사 계정) */
  ADMIN = "ADMIN",
  /** 사용자(회사에 속해있는 사원 계정) **/
  USER = "USER",
}

export interface ILoginFetc {
  email: string;
  password: string;
}

/**
 * @interface IResLogin 로그인 시 응답값
 * @property {string} id 유저 아이디값
 * @property {string} access_token 토큰
 * @property {string} role 권한
 * @property {string} expire_date 토큰 만료 기간
 * @property {string} status 상태 (dump = 임시비밀번호 발급상태, info = 상세 정보 입력 해야되는 상태, success = 사용 가능 상태)
 * @property {string} is_service 서비스 소유 확인
 */
export interface IResLogin {
  data: {
    id: string;
    access_token: string;
    role: string;

    expire_date: string;
    status: string;
    is_service: boolean;
  };
}

/**
 * guide_flag: 24.06.24 UIUX 1차 배포 이후 가이드 팝업 확인 여부
 */
export interface ITokenInfo {
  data: {
    id: number;
    cp_name: string;
    email: string;
    role: string;
    manager_name: string;
    company_id: number;
    reference_id: number;
    service_type_list?: string[];
    guide_flag?: boolean;
  };
}

export interface IResPassWord {
  data: {
    authority: string;
    status: string;
  };
}

export interface IResChannelList {
  data: {
    list: IChannelVo[];
  };
}

/**
 * 상단 헤더 채널 정보
 * @property {number} id 채널 id
 * @property {string} code 채널 코드
 * @property {string} name 채널명
 * @property {string} logo 채널 로고
 * @property {string} type 채널 타입
 */
export interface IChannelVo {
  id: number;
  code: string;
  name: string;
  logo?: string;
  type?: string;
}
